import { useDispatch, useSelector } from "react-redux";

import DataTable from "react-data-table-component";
import { ErrorBanner } from "../../components/banner";
import { FetchCategories } from "../../redux/category";
import { IoPencilOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { Section } from "../../components/section";
import styled from "styled-components";
import { useEffect } from "react";

export const CategoryList = () => {
  const { categories, error } = useSelector((state) => state.category);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(FetchCategories());
  }, [dispatch]);

  const columns = [
    {
      name: "Title",
      selector: (row) => row.name,
      sortable: true,
    },

    {
      cell: (row) => (
        <DataRowActionsContainer>
          <Link to={`/categories/${row.id}/edit`} state={{ category: row }}>
            <IoPencilOutline />
          </Link>
        </DataRowActionsContainer>
      ),
      allowOverflow: true,
      button: true,
      width: "56px",
    },
  ];

  return (
    <Section>
      {error && <ErrorBanner text={error} />}

      <DataTable
        columns={columns}
        data={categories}
        striped
        persistTableHead
        pagination
        highlightOnHover
        compact
        fixedHeader
        responsive
      />
    </Section>
  );
};

const DataRowActionsContainer = styled.div`
  display: flex;
  align-items: center;

  p {
    margin: 0;
    padding: 0;
  }

  svg {
    margin-right: 1rem;
    cursor: pointer;
  }
`;
